<template>
  <div class="content px-6 py-12">
    <h2 class="text-center pb-8 display-1">Company</h2>
    <table class="mx-auto">
      <tr v-for="infoRow in infoRows" :key="infoRow.label">
        <td
          class="info-label text-right font-weight-bold py-2"
          v-text="infoRow.label"
        />
        <td class="pl-6" v-text="infoRow.text" />
      </tr>
    </table>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component({ name: "Company" })
export default class Company extends Vue {
  infoRows = [
    { label: "会社名", text: "株式会社anytalk" },
    { label: "設立", text: "2019年12月11日" },
    // { label: "所在地", text: "東京都港区南青山2丁目2番15号 ウィン青山942" },
    // { label: "代表者", text: "吉岡 聖章" },
    { label: "事業", text: "インターネットサービス事業の企画、開発、運営など" },
    { label: "連絡先", text: "info@anytalk.jp" }
  ];
}
</script>

<style lang="scss" scoped>
.content {
  background: #f8f8f8;
  width: 100%;
}

.info-label {
  width: 50px;
}
</style>
